// extracted by mini-css-extract-plugin
export default {"plansContainer":"styles_plansContainer__JfXa5"};